module.exports = __webpack_public_path__ + "static/media/hustle_1.627137ca.svg";